// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5666":"d3755ca5c9e8b3d5","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};